// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"361":"0794c852","457":"48bfd6de","474":"900eb971","506":"12513c0a","729":"96be1b10"}[chunkId] + ".js";
};